import React from 'react';
import { serializeJsonLd } from '@apps/utils/serialize-json-ld';
import Head from 'next/head';

import { organizationSchema, webSiteSchema } from './config';
import { SiteStructuredDataProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const SiteStructuredData: React.FC<SiteStructuredDataProps> = () => {
  // =============== VIEWS
  return (
    <Head>
      <script
        type="application/ld+json"
        key="organization-schema"
        dangerouslySetInnerHTML={{
          __html: serializeJsonLd(organizationSchema),
        }}
      />
      <script
        type="application/ld+json"
        key="website-schema"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(webSiteSchema) }}
      />
    </Head>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default SiteStructuredData;
